// src/utils/phone.js (3.49.17)
// The same phone and fax number rules as the backend's lib/phone.js
// (Google's libphonenumber): checked, saved as +18007668732, shown as
// (800) 766-8732 for US/Canada and +44 20 7946 0958 for other countries.
//   phone(x)   any country; without "+", a US or Canada number
//   fax(x)     US and Canada (and US territories) only: faxing stays on +1
//   display(x) the nice form of a saved number
import { parsePhoneNumberFromString } from 'libphonenumber-js';

const FAX_COUNTRIES = ['US', 'CA', 'PR', 'VI', 'GU', 'AS', 'MP'];
function parse(input) {
  const raw = String(input || '').trim().replace(/^00(?=\d)/, '+');
  if (!raw) return null;
  try { const n = parsePhoneNumberFromString(raw, 'US'); return n && n.isValid() ? n : null; } catch { return null; }
}
const show = n => (n.countryCallingCode === '1' ? n.formatNational() : n.formatInternational());

export function phone(input) {
  if (!String(input || '').trim()) return { ok: true, e164: '', display: '' };
  const n = parse(input);
  return n ? { ok: true, e164: n.number, display: show(n) } : { ok: false };
}
export function fax(input) {
  const n = parse(input);
  return n && n.countryCallingCode === '1' && FAX_COUNTRIES.includes(n.country) ? { ok: true, e164: n.number, display: show(n) } : { ok: false };
}
export function display(value) {
  const n = parse(value);
  return n ? show(n) : String(value || '');
}
export const PHONE_HELP = 'For a number outside the US and Canada, start with + and the country code (e.g. +44 20 7946 0958).';
